import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TagModule } from 'primeng/tag'
import { InterventionEditModel } from '../../../../core/models/intervention-edit.model'

@Component({
  selector: 'app-intervention-header',
  standalone: true,
  imports: [CommonModule, TagModule],
  templateUrl: './intervention-header.component.html',
  styleUrls: ['./intervention-header.component.scss'],
})
export class InterventionHeaderComponent {
  @Input() intervention!: InterventionEditModel

  /**
   * Format date display based on intervention dates
   */
  get formattedDate(): string {
    if (!this.intervention) return ''

    const startDate = new Date(this.intervention.startDate)
    const endDate = new Date(this.intervention.endDate)

    const startFormatted = startDate.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })

    const startTime = startDate.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    })

    const endTime = endDate.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    })

    return `${startFormatted} ${startTime} - ${endTime}`
  }

  /**
   * Obtient le libellé formaté pour la source ERP
   */
  get erpSourceLabel(): string {
    const source = this.intervention?.erpSource?.toLowerCase()
    if (!source) return ''

    // Mapper les codes sources vers des libellés plus lisibles
    switch (source) {
      case 'abm':
        return 'abm'
      case 'nrj':
        return 'nrj'
      default:
        return source.toUpperCase()
    }
  }

  /**
   * Vérifie si l'intervention est liée à Constéo
   */
  get isLinkedToConsteo(): boolean {
    return !!this.intervention?.affair.consteoId
  }
}
